import * as Library from '../library/index';
import { Guid } from './guid';

/**
 * Class: Simple
 */
export class Simple {
  public active: boolean;
  public description: string;
  public disabled: boolean;
  public hidden: boolean;
  public id: number | string;
  public name: string;
  public uid: string;
  public isFeatureDisabled: boolean;

  /**
   * hasId()
   */
  hasId() {
    return Library.isDefined(this.id);
  }

  /**
   * isActive()
   */
  isActive() {
    return Library.isTrue(this.active);
  }

  /**
   * isVisible()
   */
  isVisible() {
    return !this.hidden;
  }

  /**
   * hasDescription()
   */
  hasDescription() {
    return Library.isStringWithLength(this.description);
  }

  /**
   * hasName()
   */
  hasName() {
    return Library.isStringWithLength(this.name);
  }

  /**
   * isVisible()
   */
  hasFeatureDisabled() {
    return Library.isTrue(this.isFeatureDisabled);
  }



  /**
   * Constructor()
   */
  constructor();
  constructor(options: object)
  constructor(options?: any) {
    this.active = Library.init(options, 'active', false);
    this.description = Library.init(options, 'description');
    this.disabled = Library.init(options, 'disabled', false);
    this.hidden = Library.init(options, 'hidden', false);
    this.id = Library.init(options, 'id');
    this.name = Library.init(options, 'name');
    this.isFeatureDisabled = Library.init(options, 'isFeatureDisabled', false);
    this.uid = Guid.NEW();
  }
}
